import React, {Component} from 'react';


class Refactoring extends Component{

  constructor(props){
    super(props);
    this.state = {
        data: [],
        cod: props.match.params.cod
    };
  }

  componentDidMount() {
    debugger;
    fetch(`${process.env.PUBLIC_URL}/data/refactoring/dataset_${this.state.cod}.json`)
    .then(response => response.json())
    .then(dataset => this.setState({
      data: dataset 
    }));
  }

  render(){
    return(
      <div className="container">
        <div className="row justify-content-center">
          <div>
            <a href={`${process.env.PUBLIC_URL}`} className="previous" rel="noopener noreferrer">&laquo; Back</a>
            <table className="table table-sm table-responsive table-bordered font-weight-light">
              <thead className="">
                <tr>
                  <th className="text-center" colSpan={7} scope="col">Student {this.state.cod}</th>
                </tr>
                <tr>
                  <th className="text-center" scope="col">#</th>
                  <th className="text-center" scope="col">Entity before</th>
                  <th className="text-center" scope="col">Entity after</th>
                  <th className="text-center" scope="col">Refactoring</th>
                  <th className="text-center" scope="col">Level</th>
                </tr>
              </thead>
              <tbody>
                  {this.state.data.map((refactoring, index) => {
                    return(
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td><code>{refactoring.entity_before}</code></td>
                        <td><code>{refactoring.entity_after}</code></td> 
                        <td>{refactoring.refactoring_name}</td>
                        <td>{refactoring.level}</td>
                      </tr>
                    )
                  })}
              </tbody>
            </table>
            <a href={`${process.env.PUBLIC_URL}`} className="previous" rel="noopener noreferrer">&laquo; Back</a>
          </div>
        </div>
      </div>
    )
  }
}

export default Refactoring;